import React from "react";
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import './footer.css';

const Footer = () => {
  return (
    <div className="footer-color  mt-5 h-100">
      <div className="mt-4 text-white">
        <h5 className="pt-4 text-center">Follow Us On</h5>
        
        <div className="pt-3 d-flex justify-content-center">
          <p className="ms-3 fs-3"><FaInstagram></FaInstagram></p>
          <p className="ms-3 fs-3"><FaFacebook></FaFacebook></p>
          <p className="ms-3 fs-3"><FaTwitter></FaTwitter></p>
          <p className="ms-3 fs-3"><FaLinkedin></FaLinkedin></p>
          <p className="ms-3 fs-3"><FaGithub></FaGithub></p>
        </div>
        <hr className="container text-center"></hr>
        <div>
            <p className="text-center mt-4 pb-3"><small className="text-secondary ">&#169;copy right strict 2k22</small></p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
